import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Drawer,
  Grid2,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { colors } from "../../theme/theme";
import { CustomBtn, SecondaryBtn } from "../Common/CustomBtn";
import { Cancel, Close, Delete, Edit } from "@mui/icons-material";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/config/config";

const EventDrawer = ({ drawerState, setDrawerState, selectedEvent }) => {
  const navigate = useNavigate();
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);

  const handleDeleteEvent = async (req, res) => {
    const response = await axiosInstance.delete(
      `/exerciseevent/deleteEvent?eventId=${selectedEvent.id}`
    );

    setOpenDeleteModal(false);

    window.location.reload();
  };

  return (
    <Drawer
      anchor={"right"}
      open={drawerState}
      sx={{
        "& .MuiDrawer-paper": {
          width: "75%",
          border: "1px solid #000",
          backgroundColor: "#fff",
        },
      }}
      onClose={() => setDrawerState(false)}
    >
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 4,
            py: 2,
            borderBottom: "1px solid #000",
          }}
        >
          <Typography
            sx={{
              fontSize: "23px",
              fontFamily: "Inter-SemiBold",
              color: colors.textColor,
            }}
          >
            Exercise View
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 2,
              width: "50%",
              alignItems: "center",
              justifyContent: "end",
            }}
          >
            <SecondaryBtn
              onClick={() =>
                navigate("/calendar/createexerciseevents", {
                  state: {
                    event: {
                      id: selectedEvent.id,
                      mediaURL: selectedEvent?.extendedProps.mediaURL,
                      title: selectedEvent?.title,
                      startDateTime: selectedEvent?.extendedProps.start,
                      description: selectedEvent?.extendedProps.description,
                      recurrenceType:
                        selectedEvent.extendedProps.recurrenceType,
                      recurrenceEndDate:
                        selectedEvent.extendedProps.recurrenceEndDaye,
                      categories: selectedEvent?.extendedProps.exercise,
                      parentEventId: selectedEvent?.extendedProps.parentEventId,
                    },
                  },
                })
              }
              text="Edit"
              Icon={Edit}
              noMb
              noMt
              width="30%"
            />
            <SecondaryBtn
              onClick={() => setOpenDeleteModal(true)}
              text="Delete"
              Icon={Delete}
              noMb
              noMt
              width="30%"
            />
            <SecondaryBtn
              onClick={() => setDrawerState(false)}
              text="Close"
              Icon={Close}
              noMb
              noMt
              width="30%"
            />
          </Box>
        </Box>

        <Box sx={{ p: 2 }}>
          {selectedEvent?.extendedProps.mediaURL ? (
            selectedEvent.extendedProps.mediaURL.match(
              /\.(mp4|webm|ogg|mov)$/i
            ) ? (
              <video
                src={selectedEvent.extendedProps.mediaURL}
                style={{
                  width: "100%",
                  height: "350px",
                  objectFit: "contain",
                }}
                controls
              />
            ) : (
              <img
                src={selectedEvent.extendedProps.mediaURL}
                alt="event preview"
                style={{
                  width: "100%",
                  height: "350px",
                  objectFit: "contain",
                }}
              />
            )
          ) : (
            <img
              src={require("../../assets/images/content-image1.png")}
              alt="placeholder"
              style={{
                width: "100%",
                height: "350px",
                objectFit: "cover",
              }}
            />
          )}
          <Box
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Stack direction="row" spacing={2}>
              <Typography
                sx={{
                  color: colors.textColor,
                  fontSize: "24px",
                  fontFamily: "Inter-SemiBold",
                }}
              >
                {selectedEvent?.title}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: colors.primary,
                  px: 1,
                }}
              >
                {selectedEvent?.extendedProps.start && (
                  <Typography
                    sx={{
                      color: "#fff",
                      fontSize: "14px",
                      fontFamily: "Inter-Medium",
                    }}
                  >
                    {format(
                      new Date(selectedEvent?.extendedProps.start),
                      "MMMM d, yyyy"
                    )}
                  </Typography>
                )}
              </Box>
            </Stack>
            <Typography
              sx={{
                color: "#00000080",
                fontSize: "22px",
                fontFamily: "Inter-Regular",
                py: 1,
              }}
            >
              {selectedEvent?.extendedProps.description}
            </Typography>
            {/* <Typography
              sx={{
                color: "#00000080",
                fontSize: "16px",
                fontFamily: "Inter-Light",
              }}
            >
              Ut enim ad minim veniam uis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat Ut enim ad minim veniam
              uis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
              commodo consequat Ut enim ad minim veniam uis nostrud exercitation
              ullamco laboris nisi ut aliquip ex ea commodo consequat Ut enim ad
              minim veniam uis nostrud exercitation ullamco laboris nisi ut
              aliquip ex ea commodo consequat Ut enim ad minim veniam uis
              nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
              consequat
            </Typography> */}

            <Grid2 container spacing={2} sx={{ mt: 2 }}>
              {selectedEvent?.extendedProps.exercise.length > 0 &&
                selectedEvent?.extendedProps.exercise.map((item, index) => (
                  <Grid2 item size={{ xs: 6 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: colors.primary,
                        px: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#fff",
                          fontSize: "14px",
                          fontFamily: "Inter-Medium",
                        }}
                      >
                        {item}
                      </Typography>
                    </Box>
                  </Grid2>
                ))}
              {/* <Typography
                                  sx={{
                                    color: colors.textColor,
                                    fontSize: "16px",
                                    fontFamily: "Inter-Regular",
                                  }}
                                >
                                  Level:{" "}
                                  <Typography
                                    component={"span"}
                                    sx={{
                                      color: colors.primary,
                                      fontSize: "16px",
                                      fontFamily: "Inter-Regular",
                                    }}
                                  >
                                    Beginner
                                  </Typography>
                                </Typography> */}
              {/* <Grid2 item size={{ xs: 6 }}>
                                <Typography
                                  sx={{
                                    color: colors.textColor,
                                    fontSize: "16px",
                                    fontFamily: "Inter-Regular",
                                  }}
                                >
                                  Exercise:{" "}
                                  <Typography
                                    component={"span"}
                                    sx={{
                                      color: colors.primary,
                                      fontSize: "16px",
                                      fontFamily: "Inter-Regular",
                                    }}
                                  >
                                    Cardio
                                  </Typography>
                                </Typography>
                              </Grid2> */}
              {/* <Grid2 item size={{ xs: 6 }}>
                                <Typography
                                  sx={{
                                    color: colors.textColor,
                                    fontSize: "16px",
                                    fontFamily: "Inter-Regular",
                                  }}
                                >
                                  Equipment:{" "}
                                  <Typography
                                    component={"span"}
                                    sx={{
                                      color: colors.primary,
                                      fontSize: "16px",
                                      fontFamily: "Inter-Regular",
                                    }}
                                  >
                                    Dumbbells
                                  </Typography>
                                </Typography>
                              </Grid2> */}
              {/* <Grid2 item size={{ xs: 6 }}>
                                <Typography
                                  sx={{
                                    color: colors.textColor,
                                    fontSize: "16px",
                                    fontFamily: "Inter-Regular",
                                  }}
                                >
                                  Cal Burned:{" "}
                                  <Typography
                                    component={"span"}
                                    sx={{
                                      color: colors.primary,
                                      fontSize: "16px",
                                      fontFamily: "Inter-Regular",
                                    }}
                                  >
                                    150 kcal
                                  </Typography>
                                </Typography>
                              </Grid2> */}
            </Grid2>
          </Box>
        </Box>
      </Box>
      <Dialog open={openDeleteModal} onClose={() => setOpenDeleteModal(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this event?
            {selectedEvent?.extendedProps.parentEventId && (
              <Box
                sx={{
                  mt: 2,
                  backgroundColor: "#FFF3CD",
                  border: "1px solid #FFECB5",
                  padding: "12px",
                  borderRadius: "8px",
                }}
              >
                <Typography sx={{ color: "#856404", fontSize: "14px" }}>
                  ⚠️ This is part of a recurring series. Deleting it will not
                  affect the base event or future recurring events.
                </Typography>
              </Box>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <SecondaryBtn
            onClick={() => setOpenDeleteModal(false)}
            text="Cancel"
            Icon={Cancel}
            noMb
            noMt
            width="30%"
          />
          <CustomBtn
            text="Delete"
            noIcon
            width={"30%"}
            onClick={handleDeleteEvent}
          />
        </DialogActions>
      </Dialog>
    </Drawer>
  );
};

export default EventDrawer;
